<ng-container *ngIf="type && item">
  <a [class.font-weight-medium]="strong" [routerLink]="route" *ngIf="showLink && !linkInfo; else simple">
    {{ name || item[bindLabel] }}
  </a>
  <ng-template #simple>
    <span [class.font-weight-medium]="strong">
      {{ name || item[bindLabel] }}
    </span>
  </ng-template>

  <ng-container *ngIf="showInfo">
    <br>
    <a [routerLink]="route" *ngIf="showLink && linkInfo; else simpleInfo">
      {{ info || item[bindInfo] }}
    </a>
    <ng-template #simpleInfo>
      <small class="text-muted">
        {{ info || item[bindInfo] }}
      </small>
    </ng-template>
  </ng-container>

</ng-container>
